module.exports = __webpack_public_path__ + "img/campus_Image_c.708ca9e8.png";